import React from "react";
import HiveIcon from "./logos/hive_logo.svg?react";
import AlexaIcon from "./logos/alexa_logo.svg?react";
import GoogleIcon from "./logos/google_logo.svg?react";

export const consentUiByClient = {
    "alexa": {
        logos: [
            { label: "Hive", node: <HiveIcon /> },
            { label: "Alexa", node: <AlexaIcon /> }
        ],
        title: "Ready to control Hive with Alexa?",
        subtitle: 'Tap "Allow" to link Hive to your Amazon Alexa account.'
    },
    "google": {
        logos: [
            { label: "Hive", node: <HiveIcon /> },
            { label: "Google", node: <GoogleIcon />, height: "90px", width: "173px" }
        ],
        title: "Hive services are now available with\n" +
            "the Google Assistant on Google Home",
        subtitle: 'To control your Hive devices with the Google Assistant,\n' +
            'enable your Hive account in the Google Home app'
    }
};

export const defaultConsentUi = {
    logos: [{ label: "Hive", node: <HiveIcon /> }],
    title: "Review access request",
    subtitle: "This app is asking for permission to access your Hive devices."
};
